import { frontendURL } from '../../../../helper/URLHelper';

const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');
const AgentReportsOverview = () => import('./AgentReportsOverview.vue');
const AgentReportsConversation = () => import('./AgentReportsConversation.vue');
const LabelReports = () => import('./LabelReports.vue');
const InboxReports = () => import('./InboxReports.vue');
const TeamReports = () => import('./TeamReports.vue');
const CsatResponses = () => import('./CsatResponses.vue');
const BotReports = () => import('./BotReports.vue');
const LiveReports = () => import('./LiveReports.vue');
const SLAReports = () => import('./SLAReports.vue');
const InboundReports = () => import('./InboundReports.vue');
const OutboundReports = () => import('./OutboundReports.vue');
const CampaignsReports = () => import('./CampaignsReports.vue');
const UraNavigationReports = () => import('./UraNavigationReports.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'OVERVIEW_REPORTS.HEADER',
        icon: 'arrow-trending-lines',
        keepAlive: false,
      },
      children: [
        {
          path: '',
          redirect: 'campaigns',
        },
        {
          path: 'overview',
          name: 'account_overview_reports',
          roles: ['administrator', 'supervisor', 'master'],
          component: LiveReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'REPORT.HEADER',
        icon: 'chat',
        keepAlive: false,
      },
      children: [
        {
          path: 'conversation',
          name: 'conversation_reports',
          roles: ['administrator', 'supervisor', 'master'],
          component: Index,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'CSAT_REPORTS.HEADER',
        icon: 'emoji',
        keepAlive: false,
      },
      children: [
        {
          path: 'csat',
          name: 'csat_reports',
          roles: ['administrator', 'supervisor', 'master'],
          component: CsatResponses,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'BOT_REPORTS.HEADER',
        icon: 'bot',
        keepAlive: false,
      },
      children: [
        {
          path: 'bot',
          name: 'bot_reports',
          roles: ['administrator', 'supervisor', 'master'],
          component: BotReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports/agent'),
      component: SettingsContent,
      props: {
        headerTitle: 'AGENT_REPORTS.HEADER',
        icon: 'people',
        keepAlive: false,
      },
      children: [
        {
          path: 'overview',
          name: 'agent_reports_overview',
          roles: ['administrator', 'supervisor', 'master'],
          component: AgentReportsOverview,
        },
        {
          path: 'conversation',
          name: 'agent_reports_conversation',
          roles: ['administrator', 'supervisor', 'master'],
          component: AgentReportsConversation,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'LABEL_REPORTS.HEADER',
        icon: 'tag',
        keepAlive: false,
      },
      children: [
        {
          path: 'label',
          name: 'label_reports',
          roles: ['administrator', 'supervisor', 'master'],
          component: LabelReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'INBOX_REPORTS.HEADER',
        icon: 'mail-inbox-all',
        keepAlive: false,
      },
      children: [
        {
          path: 'inboxes',
          name: 'inbox_reports',
          roles: ['administrator', 'supervisor', 'master'],
          component: InboxReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'TEAM_REPORTS.HEADER',
        icon: 'people-team',
      },
      children: [
        {
          path: 'teams',
          name: 'team_reports',
          roles: ['administrator', 'supervisor', 'master'],
          component: TeamReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'SLA_REPORTS.HEADER',
        icon: 'document-list-clock',
        keepAlive: false,
      },
      children: [
        {
          path: 'sla',
          name: 'sla_reports',
          roles: ['administrator', 'supervisor', 'master'],
          component: SLAReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'SIDEBAR.REPORTS_INBOUND',
        icon: 'arrow-download',
        keepAlive: false,
      },
      children: [
        {
          path: 'inbound',
          name: 'inbound_reports',
          roles: ['administrator', 'supervisor', 'master'],
          component: InboundReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'SIDEBAR.REPORTS_OUTBOUND',
        icon: 'arrow-up',
        keepAlive: false,
      },
      children: [
        {
          path: 'outbound',
          name: 'outbound_reports',
          roles: ['administrator', 'supervisor', 'master'],
          component: OutboundReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'REPORT.CAMPAIGNS.HEADER',
        icon: 'sound-source',
        keepAlive: false,
      },
      children: [
        {
          path: 'campaigns',
          name: 'campaign_reports',
          roles: ['administrator', 'supervisor', 'master'],
          component: CampaignsReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'SIDEBAR.REPORTS_URA_NAVIGATION',
        icon: 'navigation',
        keepAlive: false,
      },
      children: [
        {
          path: 'ura_navigation',
          name: 'ura_navigation_reports',
          roles: ['administrator', 'supervisor', 'master'],
          component: UraNavigationReports,
        },
      ],
    },
  ],
};
